<template>
  <container :class="['p-1', 'page-meta']">
    <flex>
      <flex-col :span="12" lg12 sm24>
        <h2 v-html="title" v-if="title" :class="['text-2xl', 'my-3']" />
      </flex-col>
      <flex-col :span="12" lg12 sm24 :class="['lg:text-right']">
        <breadcrumbs tag="router-link" align="auto" :color-lightness="$root.colors.bgColorLightness" :color="$root.colors.primary" :class="['my-3']">
          <breadcrumbs-item v-for="(item, index) in breadcrumbs" :title="item.title" :to="item.to" :key="index">{{ item.title.toUpperCase() }}</breadcrumbs-item>
        </breadcrumbs>
      </flex-col>
      <flex-col :span="24" lg24 sm24>
        <divider :class="['my-3']" />
        <paragraph v-html="description" v-if="description" :class="['page-meta-description']" />
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'PageMeta',
  mixins: [
    methods
  ],
  data () {
    return {
      path: null,
      title: null,
      description: null,
      breadcrumbs: [],
      root: this.$root.config.pagesMeta
    }
  },
  watch: {
    '$route.path' () {
      this.getPath()
      this.setBreadcrumbs()
    }
  },
  mounted () {
    this.onMounted()
  },
  created () {
    this.onCreated()
  },
  methods: {
    onCreated () {
      this.$root.$on('swatch-change', () => {
        this.onMounted()
      })
      this.$root.$on('theme-change', () => {
        this.onMounted()
      })
    },
    onMounted () {
      this.getPath()
      this.setBreadcrumbs()
    },
    resetPageMeta (description) {
      this.path = null
      this.title = null
      this.description = description || null
      this.breadcrumbs = []
      this.addMetaTags('', [])
    },
    setBreadcrumbs () {
      const parts = window.location.pathname.split('/')
      const breadcrumbs = []
      if (this.$route.path === '/') {
        this.breadcrumbs = []
        return
      }
      parts.forEach((part, index) => {
        breadcrumbs.push({
          title: part === '' ? 'Home' : this.$lang.sections[part] || part.replace(/-/g, ' '),
          to: index === 0 ? '/' : index === 1 ? '/' + part : '/' + parts[index - 1] + '/' + part
        })
      })
      this.breadcrumbs = breadcrumbs
    },
    getPath () {
      this.path = this.$route.path === '/' ? '/index' : this.$route.path
      this.getPageMeta()
    },
    getPageMeta () {
      this.$http({
        method: 'GET',
        url: `${this.root}${this.path}.json`
      }).then(response => {
        if (response.status === 200 && response.data) {
          this.setPageData(response.data)
        }
      }).catch(error => {
        this.resetPageMeta(this.$lang.didYouSetMetaDataFile(error, this.$route.fullPath))
        console.log(error)
      })
    },
    setPageData (data) {
      const title = data.title || null
      const description = data.description || null
      this.title = title
      this.description = `${description}.`
      this.setPageTitle(title)
      this.addMetaTags(description || this.title || '', data.keywords)
      this.$root.$emit('documentation', data.documentation)
      this.$nextTick(() => {
        this.enableRoutePush('.page-meta-description')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-meta.vue